<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1"><span class="text_">About the Author</span></h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2"> </p>
<p class="block_3"><span class="text_1">Susie King has always loved writing stories and is highly imaginative, with a keen sense of the drama of life. Susie has been a chalet girl, daffodil picker, au pair, MP’s secretary, natural health therapist and went to a convent school where she was always getting into trouble. She loves travelling, going to the movies, trees, fish &amp; chips, snow, the sea and anything to do with space.</span></p>
<p class="block_4"><span class="text_2"><br class="calibre1" id="calibre_pb_0"/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?697adaa9